/**
 * 浏览类埋点限频：窗口内同一用户+同一路径只上报一次。异常则放行。
 * Site/Visit 1 小时（完整 URL）；Site/ViewProduct / Collection/View 10 分钟（去 query/hash）。
 */
import storage from './storage';
import storageKeys from './storageKeys';

var LIMIT_MS = {
  'Site/Visit': 60 * 60 * 1000,
  'Site/ViewProduct': 10 * 60 * 1000,
  'Collection/View': 10 * 60 * 1000
};

function getUserId(identity) {
  identity = identity || {};
  var email = String(identity.email || '').trim().toLowerCase();
  if (email) return email;
  var keys = ['phone', 'customerId', 'uid', 'oid'];
  for (var i = 0; i < keys.length; i++) {
    if (identity[keys[i]]) return String(identity[keys[i]]);
  }
  return '';
}

function getPath(eventType, pathName) {
  var path = String(pathName || '');
  if (eventType === 'Site/Visit') return path;
  return path.split(/[?#]/)[0];
}

/** 丢掉已过限频窗口的条目，避免 localStorage map 只增不减。 */
function pruneExpired(map, now) {
  var next = {};
  for (var k in map) {
    if (!Object.prototype.hasOwnProperty.call(map, k)) continue;
    var last = Number(map[k] || 0);
    if (!last) continue;
    var eventType = k.split('|')[1];
    var ms = LIMIT_MS[eventType] || LIMIT_MS['Site/Visit'];
    if (now - last < ms) {
      next[k] = last;
    }
  }
  return next;
}

/** @returns {boolean} true=可以上报 */
function canReport(eventType, companyId, identity, pathName) {
  try {
    var ms = LIMIT_MS[eventType];
    if (!ms) return true;

    var userId = getUserId(identity || {});
    if (!userId) return true;

    var key = [companyId, eventType, userId, getPath(eventType, pathName)].join('|');
    var map = storage.getLocalJSON(storageKeys.EVENT_REPORT_LIMIT, {}) || {};
    var now = Date.now();
    var last = Number(map[key] || 0);
    if (last && now - last < ms) return false;

    map = pruneExpired(map, now);
    map[key] = now;
    storage.setLocal(storageKeys.EVENT_REPORT_LIMIT, JSON.stringify(map));
    return true;
  } catch (e) {
    return true;
  }
}

export default { canReport: canReport };
